require("./data_variable.js");
require("./data_changevariableby.js");
require("./data_setvariableto.js");
